<template>
  <el-row class="dob-picker">
    <el-select
      v-model="month"
      filterable
      :placeholder="this.labels[1]"
      @change="changeMonth($event)"
    >
      <el-option
        v-for="(param, key) in monthsList"
        :key="key"
        :label="param.label"
        :value="param.value"
      />
    </el-select>
    <el-select
      v-model="day"
      filterable
      :placeholder="this.labels[0]"
      @change="changeDay($event)"
    >
      <el-option
        v-for="(param, key) in daysList"
        :key="key"
        :label="param.label"
        :value="param.value"
        :disabled="param.disabled"
      />
    </el-select>
    <el-select
      v-model="year"
      filterable
      :placeholder="this.labels[2]"
      @change="changeYear($event)"
    >
      <el-option
        v-for="(param, key) in yearsList"
        :key="key"
        :label="param.label"
        :value="param.value"
        :disabled="param.disabled"
      />
    </el-select>
  </el-row>
</template>

<script>
export default {
  name: 'DobPicker',
  data() {
    return {
      minage: null,
      maxage: null,
      yearsList: [],
      birthdate: '',
      monthsList: [],
      daysList: [],
      labels: [],
      fields: ['day', 'month', 'year'],
      day: '',
      month: '',
      year: '',
      rules: {
        select: [{required: true, message: 'Please input a valid First Name', trigger: 'blur'}]
      }
    };
  },
  created() {
    this.getYearsList();
    this.getDaysList();
    this.setData();
    this.changeDateOfBirth(this.$attrs.birthdate);
  },
  methods: {
    updateDateOfBirth() {
      if (this.month && this.day && this.year) {
        this.birthdate = this.year + '-' + this.month + '-' + this.day;
        this.$emit('update:birthdate', this.birthdate);
      }
    },
    setData() {
      for (let i = 1; i <= 12; i++) {
        this.monthsList.push({
          value: i,
          label: this.$t('components.dobPicker.months.' + i),
        })
      }

      this.fields.forEach((item) => {
        this.labels.push(this.$t('components.dobPicker.labels.' + item))
      });
    },
    changeDateOfBirth(dob) {
      if (dob) {
        var dt = new Date(dob);
        this.month = dt.getMonth() + 1;
        this.year = dt.getFullYear();
        this.day = dt.getDate();
      }
    },
    changeMonth(month) {
      this.daysList.forEach(function (obj) {
        delete obj.disabled
        if (obj.label == 30 && month == 2) {
          obj.disabled = true
        }
        if (obj.label == 31 && ([4, 6, 9, 11].includes(month) || month == 2) ) {
          obj.disabled = true
        }
      });
      this.updateDateOfBirth();
    },
    changeYear() {
      this.updateDateOfBirth();
    },
    changeDay(day) {
      if (day == 29 && this.month == 2) {
        this.yearsList.forEach(function (obj) {
          if (obj.label % 4 !== 0) {
            obj.disabled = true;
          }
        });
      } else {
        this.yearsList.forEach(function (obj) {
          delete obj.disabled
        });
      }
      this.updateDateOfBirth();
    },
    getYearsList() {
      const now = new Date().getFullYear(),
          startYear = now - this.$attrs.minage,
          endYear = startYear - this.$attrs.maxage,
          years = [];

      for (let i = startYear; i >= endYear; i--) {
        years.push({
          'label': i,
          'value': i
        });
      }
      this.yearsList = years;
    },
    getDaysList() {
      const days = [];
      for (let i = 1; i <= 31; i++) {
        days.push({
          'label': i,
          'value': i
        });
      }
      this.daysList = days;
    },
  },
};
</script>
